import { Column, Columns } from '@vtex/admin-ui'
import {
  Accumulate,
  AccumulateManualPrices,
  Accumulations,
  AdditionalInformation,
  Conditions,
  MaxItemsPerAttribute,
  MaxItemsPerCart,
  MaxUsage,
  MaxUsagePerClient,
  Origin,
  PromotionHighlight,
  Restrictions,
  SalesChannels,
  Sellers,
  Storefront,
} from 'ui'
import { GeneralInformation } from '../../GeneralInformation'
import { StackedBoxes } from '../../StackedBoxes'
import { CampaignEffect } from './CampaignEffect'
import { AudienceSection } from './AudienceSection'
import { AudienceConditions } from './AudienceConditions'

export default function CampaignForm() {
  return (
    <Columns space="$space-20">
      <Column units={7}>
        <GeneralInformation />
        <AudienceSection name="campaign.audiences" />
        <CampaignEffect name="campaign" />
        <Conditions>
          <AudienceConditions />
        </Conditions>
        <Restrictions>
          <MaxUsage name="restrictions.maxUsage" />
          <MaxUsagePerClient name="restrictions.maxUsagePerClient" />
          <MaxItemsPerCart name="restrictions.maxItemsPerCart" />
          <MaxItemsPerAttribute name="restrictions.maxItemsPerAttribute" />
        </Restrictions>
        <Accumulations>
          <Accumulate name="restrictions.accumulate" />
          <AccumulateManualPrices name="restrictions.accumulateWithManualPrices" />
        </Accumulations>
        <Storefront>
          <PromotionHighlight name="storefront.highlight" />
          <AdditionalInformation name="storefront.additionalInformation" />
        </Storefront>
      </Column>
      <Column>
        <StackedBoxes>
          <Origin name="restrictions.origin" />
          <SalesChannels name="restrictions.salesChannels" />
          <Sellers name="restrictions.sellers" />
        </StackedBoxes>
      </Column>
    </Columns>
  )
}
